import { useMutation, type UseMutationOptions, useQueryClient } from 'react-query';
import { sharedWorkflowService } from 'api/services';
import { useSiteDetection } from 'shared/hooks';
import { QUERY_KEYS } from '../../../../../../api/query-keys';

type ArchiveWorkflowVariables = string;
type ArchiveWorkflowOptions = UseMutationOptions<unknown, Error, ArchiveWorkflowVariables>;

export const useArchiveWorkflow = (receivedOptions?: ArchiveWorkflowOptions) => {
  const { site } = useSiteDetection();
  const queryClient = useQueryClient();

  return useMutation(
    async (workflowId: ArchiveWorkflowVariables) => {
      return await sharedWorkflowService.archiveWorkflow(site, workflowId);
    },
    {
      ...receivedOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries(QUERY_KEYS.workflows());
        if (receivedOptions?.onSuccess) {
          receivedOptions.onSuccess(data, variables, context);
        }
      },
    }
  );
};
